import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import TraditionalEditorActions from './TraditionalEditorActions';
import BottomControls from './BottomControls';
import UndoRedoContainer from '../../containers/undoRedoContainer';
//import { usePopup } from '../../context/PopupContext';
import { useResume } from '../../context/ResumeContext';
import { FINAL_RESUME } from '../../constants/constants';
import ArrowUpDir from '../../assets/images/top-dir-arrow.svg';
import Splash from './Splash';
import HeaderComponent from './HeaderComponent';
import TemplateSelector from './TemplateSelector';
import TransitionBanner from './TransitionBanner';
import { getResumeName } from '../../helper';
//const TemplateSelector = React.lazy(() => import('./TemplateSelector'));

const Layout = (props) => {
    const history = useHistory();
    const [editIcon, setEditIcon] = useState(true);
    const [editResumeName, setEditResumeName] = useState(false);
    const [showTemplates, setShowTemplates] = useState(false);
    const [showBeforeUnload, setShowBeforeUnload] = useState(false);
    const {
        resume,
        handlers
    } = useResume();
    //const popups = usePopup();
    // useEffect(() => {
    //     popups.configurePopup(POPUP_TYPES);
    // }, []);
    const getEditIcon = () => {
        return (editIcon && 
            <i className="icon-pencil" 
            onClick={(e) => {
                setEditIcon(false)
                setEditResumeName(true)
            }}></i>  
        )
    }
    const getEditInputBox = () => {
        return (editResumeName && 
            <input type="text" className="edit-input-field" name="resume_name" value={resume.resume_name}
                onChange={(e) => {
                    handlers.updateResumePreview({resume_name: e.target.value}, true)
                }}
                onBlur={(e) => {
                    setEditIcon(true)
                    setEditResumeName(false)
                }}
            />
        )
    }
  // Prompt message when leaving page
//   useEffect(() => {
//     function handleOnBeforeUnload(event){
//       event.preventDefault();
//       return (event.returnValue = '');
//     }
//     if(showBeforeUnload){
//         window.addEventListener("beforeunload", handleOnBeforeUnload);
//     } else {
//         window.removeEventListener("beforeunload", handleOnBeforeUnload);
//     }
//     return () => {
//       window.removeEventListener("beforeunload", handleOnBeforeUnload);
//     }
//   }, [])
    return (<>
        {props.hasOwnProperty('header') ? props.header : ''}

        {props.editorType == 'allinone' ? <>
        <TransitionBanner />
        <HeaderComponent 
          editorType={ 'allinone'}
          saveResume={handlers.onsaveResume}
          resumeLoaded={true}
          showSplash={true}
        />
            <div className={`app-editor app-allinone`}>
                <div className="left-block">
                    {props.leftPanel}
                    <div className={`app-right-panel ${props.editorType}`}>
                        <div className={`editor-block editor-${props.editorType}`}>
                        <Splash />
                        <div className="allinone-top-controls">
                            <div className="undo-redo-wrap">
                                {/** 
                                 * START
                                 * Commented out the below code to remove the undo/redo feature from the all-in-one editor.
                                 * Note: The undo/redo feature is implemented on the all-in-one editor only.
                                 * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/540
                                 * Date: 2023-12-24
                                 * */}
                                {/* <UndoRedoContainer /> */}
                                {/**
                                 * END
                                 */}
                                <div className="field-wrap">
                                    <label htmlFor="resume_name" className="label-2">Title:</label>
                                        {!editResumeName &&
                                        <p className="resume-name">
                                            {getResumeName(resume)}
                                        </p>
                                    }
                                    {getEditIcon()}
                                    {getEditInputBox()}
                                </div>
                            </div>
                            <div className="rearrenge-wrap">
                                {/* <button className="reorder-blocks" onClick={
                                    (e) => {
                                    popups.show('rearrangebox',null, null)
                                }}> */}
                                <button 
                                    className={`reorder-blocks${(props.showRearrange ? ' disabled' : '')}`} 
                                    onClick={
                                        () => {
                                        if(props.showRearrange) return null;
                                        else props.setShowRearrange(!props.showRearrange);
                                        ga4Track('app_editor_rearrange', 'RB App', 'Rearrange');
                                }}>
                                    <span className="circle"><i className="icon-grid"></i></span><span className="reorder-text">Rearrange Sections</span>
                                </button>
                            </div>
                        </div>
                        <div className={`allinone-wrap${(props.showRearrange ? ' rearrange-wrap' : '')}`}>
                            {props.left}
                        </div>
                        <div className="preview-resume-btn">
                            <div className="blue-preview-btn" onClick={() => history.push({
                                pathname: FINAL_RESUME,
                                state: {
                                    openPanel: true,
                                    referrer: `${history.location.pathname}`
                                }
                            })}>Preview Resume <span className="display-up-icon"><ArrowUpDir></ArrowUpDir></span></div>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="right-block">
                    <div className="right-block-inner">
                    <div className={`page-area ${props.editorType}-area`}>
                        <div className="resume-preview">
                                {props.right}
                            </div>
                        </div>
                    </div>
                    {/* <BottomControls setShowBeforeUnload={setShowBeforeUnload} /> */}
                    <BottomControls />
                </div>
            </div>
            
        </> : <>
            <TransitionBanner />
            <HeaderComponent 
            editorType={ 'traditional'}
            saveResume={handlers.onsaveResume}
            resumeLoaded={true}
            showSplash={true}
            />
            <div className={`app-editor app-traditional`}>
                {props.leftPanel}
                <div className={`app-right-panel ${props.editorType}`}>
                        <div className="editor-block">
                            <TraditionalEditorActions 
                                popup={props.showLoginPopUp} 
                                showPopup={(p) => { props.setShowLoginPopUp(p) }} 
                                showSplash={true} 
                                state={props.state} 
                                showTemplates={showTemplates}
                                setShowTemplates={ s => setShowTemplates(s) } 
                            />
                            {window.innerWidth >= 770 && showTemplates
                                ? <TemplateSelector
                                    resume={resume}
                                    handlers={handlers}
                                    setShowTemplates={s => setShowTemplates(s)} />
                                : props.left
                            }
                            {window.innerWidth <= 770 && showTemplates && 
                                <TemplateSelector
                                    resume={resume}
                                    handlers={handlers}
                                    setShowTemplates={s => setShowTemplates(s)} 
                                />
                            }
                        </div>
                    <div className={`page-area ${props.editorType}-area`}>
                            {/* <TraditionalEditorActions popup={props.showLoginPopUp} showPopup={(p) => { props.setShowLoginPopUp(p) }} showSplash={true} /> */}
                        <div className="resume-preview">
                            {props.right}
                        </div>
                    </div>

                </div>
            </div>
        </>
        }
    </>);
}

export default Layout;